// https://vuex.vuejs.org/en/mutations.html

import { set } from '@/utils/vuex'

export default {
  setLoader (state, data) {
    state.loader = { ...state.loader, ...data }
  },
  setCustListLoading: set('loading'),
  setFormDialogSaving: set('formDialogSaving'),
  setFormDialogSuccess: set('formDialogSuccess'),

  setUserLoggedIn (state, user) {
    state.currentUser = { ...state.currentUser, isLoggedIn: true, ...user }
  },
  setFieldPermission (state, allowView) {
    state.viewCustomFields = { ...state.viewCustomFields, isAllowed: allowView }
  },
  switchUserView (state, view) {
    state.currentUser = { ...state.currentUser, view: view }
  },
  setSnackbar (state, data) {
    state.snackbar = { ...state.snackbar, ...data }
  },
  showDialog (state, data) {
    state.dialog = { ...state.dialog, ...data }
  },
  resetDialog (state) {
    state.dialog = {
      show: false,
      type: 'alert',
      persistent: false,
      title: '',
      description: '',
      yesLabel: 'Yes',
      noLabel: 'No',
      yesHandler: null,
      yesHandlerLoading: false,
      noHandler: null,
      linkLabel: '',
      linkHandler: null
    }
  },
  savingFormDialog (state, data) {
    state.formDialog = { ...state.formDialog, saving: data }
  },
  setFormDialogResponse (state, data) {
    state.formDialog = { ...state.formDialog, saved: data.saved, alertType: data.alertType, alertMessage: data.alertMessage }
  },
  resetFormDialog (state) {
    state.formDialog = {
      show: false,
      type: 'new', // new, edit
      persistent: true,
      title: null,
      fields: { // TODO: for reusability, this shouldnt be hardcoded, should be array
        Acct_ID: null,
        OB_ID: null,
        Acct_name: null,
        Acct_DL: null,
        Date_onboarded: null,
        Last_Date_Validated: null,
        Date_Requested_change: null,
        MP_ID: null,
        Previous_MP_ID: null,
        Managed_Svc: null,
        Acct_status: null,
        AWS_Support_Type: null,
        Is_MP: null,
        Acct_Description: null
      },
      saveLabel: 'Save',
      cancelLabel: 'Cancel',
      saveHandler: null,
      saveHandlerLoading: false,
      cancelHandler: null,
      saving: false,
      saved: false,
      alertType: 'success', // success, error
      alertMessage: ''
    }
  },
  setInitialLoad (state, data) {
    state.initialLoad = data
  },
  setServerError (state, error) {
    state.serverErrorDialog = {
      show: true,
      error: error
    }
  },
  setCheckingCustomerLoading (state, loading) {
    state.accountDialog = { ...state.accountDialog, checkingCustomerLoading: loading }
  },
  setLastSyncDateTime (state, date) {
    state.lastSyncDate = date
  },
  showLogs (state, show) {
    state.changeLog.show = show
  },
  setLoadingLogs (state, loading) {
    state.changeLog.loading = loading
  },
  setLogRecords (state, logs) {
    state.changeLog.data = logs
  },
  setChangeLogRecord (state, record) {
    state.logRecord = {
      ...state.logRecord,
      ...record
    }
  },
  resetChangeLog (state) {
    state.changeLog = {
      show: false,
      id: '',
      action: 'all',
      module: 'all',
      loading: false,
      headers: [
        {
          sortable: true,
          text: 'ID',
          value: 'Log_Id',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Action',
          value: 'action',
          align: 'left'
        },
        {
          sortable: true,
          text: 'User',
          value: 'User',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Change From',
          value: 'Change_From',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Change To',
          value: 'Change_To',
          align: 'left'
        },
        {
          sortable: true,
          text: 'Created At',
          value: 'Create_Date',
          align: 'left'
        }
      ],
      startDate: null,
      endDate: null,
      highlight: false,
      data: []
    }
  },
  setChangeLog (state, log) {
    state.changeLog = {
      ...state.changeLog,
      ...log
    }
  },
  clearLogRecord (state) {
    state.logRecord = {
      id: null,
      action: null,
      module: null,
      changeFrom: null,
      changeTo: null
    }
  }
}
